import { render, staticRenderFns } from "./EbDisclosure.vue?vue&type=template&id=2bc5bd8e&scoped=true"
import script from "./EbDisclosure.vue?vue&type=script&lang=js"
export * from "./EbDisclosure.vue?vue&type=script&lang=js"
import style0 from "./EbDisclosure.vue?vue&type=style&index=0&id=2bc5bd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5bd8e",
  null
  
)

export default component.exports